import * as React from "react";
import { ConfigProvider } from "antd";
import { useThemeContext } from "./theme/ThemeProvider";
import { buildAntdTheme } from "./antdTheme";
import { FONTS } from "./theme/theme";

/** Re-applies Ant Design tokens whenever Cenna theme attrs change. */
export function ThemedConfigProvider({ children }: { children: React.ReactNode }) {
  const { theme, resolvedMode, font } = useThemeContext();
  const fontStack = FONTS.find((f) => f.id === font)?.stack.replace(/'/g, "") || "Inter";

  const antdTheme = React.useMemo(
    () =>
      buildAntdTheme({
        themeId: theme,
        resolvedMode,
        fontFamily: fontStack,
      }),
    [theme, resolvedMode, fontStack]
  );

  return <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>;
}
